import { fetch } from '@/utilitys/gecAxios'
import GecVideo from '@/components/gecVideo'

export default {
  components: { GecVideo },
  data () {
    return {
      VIDEO: '',
      player: {}
    }
  },
  created () {
    this.getVideo(this.$route.query.id)
  },

  mounted () {
  },
  methods: {
    async getVideo (id) {
      // 获取个人信息
      const { data: res } = await fetch('/video', { id: id })
      if (res.error.returnCode !== 0) return this.$Message.error('获取视频失败!')
      this.VIDEO = res.data.videoUrl || 'http://cdn.gecacademy.cn/gecfe/gec-83mb.mp4'

      this.player = new window.Aliplayer({
        'id': 'player-con',
        'source': this.VIDEO,
        'width': '100%',
        'height': '500px',
        'autoplay': true,
        'isLive': false,
        'rePlay': false,
        'playsinline': true,
        'preload': true,
        'controlBarVisibility': 'hover',
        'useH5Prism': true,
        'extraInfo': {
          'crossOrigin': 'anonymous'
        },
        'skinLayout': [
          {
            'name': 'bigPlayButton',
            'align': 'blabs',
            'x': 30,
            'y': 80
          },
          {
            'name': 'H5Loading',
            'align': 'cc'
          },
          {
            'name': 'errorDisplay',
            'align': 'tlabs',
            'x': 0,
            'y': 0
          },
          {
            'name': 'infoDisplay'
          },
          {
            'name': 'tooltip',
            'align': 'blabs',
            'x': 0,
            'y': 56
          },
          {
            'name': 'thumbnail'
          },
          {
            'name': 'controlBar',
            'align': 'blabs',
            'x': 0,
            'y': 0,
            'children': [
              {
                'name': 'progress',
                'align': 'blabs',
                'x': 0,
                'y': 44
              },
              {
                'name': 'playButton',
                'align': 'tl',
                'x': 15,
                'y': 12
              },
              {
                'name': 'timeDisplay',
                'align': 'tl',
                'x': 10,
                'y': 7
              },
              {
                'name': 'fullScreenButton',
                'align': 'tr',
                'x': 10,
                'y': 12
              },
              {
                'name': 'setting',
                'align': 'tr',
                'x': 15,
                'y': 12
              },
              {
                'name': 'volume',
                'align': 'tr',
                'x': 5,
                'y': 10
              }
            ]
          }
        ]
      }, (player) => { console.log('播放器创建了。') }
      )
    }
  }
  //   async getCourseCategory () {
  //     // 获取课程目录
  //     const ID = this.$route.query.courseId
  //     const CHILD_ID = this.$route.query.childID
  //     const { data: res } = await fetch(
  //       '/course/category',
  //       {
  //         id: ID
  //       })
  //     const DATA = res.data
  //     // console.log('需要格式化的数据', DATA)
  //     // 设置展开的那个父级
  //     DATA.map((element) => {
  //       element.expand = element.children.map((child) => {
  //         if (child.id === CHILD_ID) {
  //           // 取到，展开他的父级
  //           return true
  //         } else {
  //           return false
  //         }
  //       })
  //     })
  //     this.tree = DATA
  //   },
  //   async getCurrentPlayTo () {
  //     const courseId = this.$route.query.courseId
  //     const childCourseId = this.$route.query.childId

  //     const { data: res } = await fetch(
  //       'studyProgress/childCourse',
  //       {
  //         courseId,
  //         childCourseId
  //       })
  //     if (res.error.returnCode !== 0) return this.$Message.error('获取课程信息失败!')
  //     const DATA = res.data
  //     console.log('iiii', DATA)
  //     this.courseInfo.duration = DATA.duration || 0
  //     this.courseInfo.isFinish = DATA.isFinish
  //   },
  //   async getViewCourse () {
  //     // 获取正在播放的子课程
  //     const ID = this.$route.query.childId
  //     const { data: res } = await fetch(
  //       '/course/child',
  //       {
  //         id: ID
  //       })
  //     if (res.error.returnCode !== 0) return this.$Message.error('获取课程信息失败!')
  //     const DATA = res.data
  //     this.videoView.name = DATA.name
  //     this.videoView.videoUrl = DATA.videoUrl
  //     this.videoView.videoDuration = DATA.videoDuration || 0
  //     // console.log('go', DATA)
  //   },
  //   async getCourseData () {
  //     const TYPE = this.$route.query.type * 1
  //     const ID = this.$route.query.courseId
  //     let myres = {}
  //     if (TYPE === 300 || TYPE === 301) {
  //       // 公开课或者训练营
  //       const { data: res } = await fetch(
  //         '/course/normal/detail',
  //         {
  //           id: ID
  //         })
  //       myres = res
  //       // /
  //     } else if (TYPE === 302) {
  //       // PBL
  //       const { data: res } = await fetch(
  //         '/course/pbl/detail',
  //         {
  //           id: ID
  //         })
  //       myres = res
  //     }
  //     if (myres.error.returnCode !== 0) return this.$Message.error('获取课程信息失败!')
  //     const DATA = myres.data
  //     // console.log(DATA)
  //     // this.courseContent = DATA.catalog
  //     // 课程信息的处理
  //     this.courseInfo.tag = (function () {
  //       switch (DATA.type * 1) {
  //         case 300:
  //           return '公开课'
  //         case 301:
  //           return '训练营'
  //         case 302:
  //           return 'PBL'
  //         default:
  //           break
  //       }
  //     }())
  //     this.courseInfo.name = DATA.name
  //     // 附件的处理
  //     // DATA.attachments.map((element, index) => {
  //     //   //
  //     //   const TEMP_OBJ = {
  //     //     key: index,
  //     //     name: this.$i18n.locale === 'zh' ? element.title : element.titleEn,
  //     //     type: 'FILE',
  //     //     url: element.url
  //     //   }
  //     //   this.attachments.push(TEMP_OBJ)
  //     // })
  //   },
  //   handleBack () {
  //     this.$router.push({
  //       path: `/course?id=${this.$route.query.courseId}&type=${this.$route.query.type}`
  //     })
  //   },
  //   handleChooseVideo (item) {
  //     this.$Spin.show()
  //     this.$router.push({
  //       path: `/viewCourse?courseId=${this.$route.query.courseId}&childId=${item[0].id}&type=${this.$route.query.type}`
  //     })
  //     this.getViewCourse()
  //     setTimeout(() => {
  //       this.$Spin.hide()
  //     }, 1000)
  //   }

}



// WEBPACK FOOTER //
// ./src/views/viewVideo/viewVideo.js